import { classifyApiFailure } from './classifyApiFailure'
import { reportError } from './reportError'

/**
 * React Query 공통 onError 용. 실패 종류별 레벨·태그를 붙여 보고한다.
 * fingerprint 를 [화면, 원인, status, code] 로 둬서 같은 래퍼 줄(apis/index.ts)에서 난
 * 서로 다른 실패가 한 이슈로 섞이지 않게 한다.
 */
export function reportApiFailure(error: unknown): void {
  const failure = classifyApiFailure(error)
  const screen = window.location.pathname
  const tags: Record<string, string> = { layer: 'browser', owner: failure.owner, screen }
  if (failure.code) tags.api_code = failure.code

  reportError(error, {
    source: 'react-query',
    level: failure.level,
    tags,
    fingerprint:
      failure.owner === 'web' ? undefined : [screen, failure.owner, String(failure.status ?? ''), failure.code ?? ''],
  })
}
